var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      [
        _c("section-title", { attrs: { title: _vm.$t("message.attribute") } }),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12 no-padding" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _vm._l(_vm.data.length, function(item, index) {
                return [
                  _c(
                    "div",
                    { staticClass: "wrap-attributes-input col-md-12" },
                    [
                      _c("div", { staticClass: "form-row mb-2" }, [
                        _c("div", { staticClass: "col-4" }, [
                          _c("div", { staticClass: "form-group row" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-12 inner-attribute-name" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.data[index].name,
                                      expression: "data[index].name"
                                    }
                                  ],
                                  staticClass: "form-control form-control-sm",
                                  staticStyle: {
                                    "border-radius": ".25rem 0 0 .25rem"
                                  },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "message.attributename"
                                    ),
                                    disabled: _vm.disabled,
                                    type: "text"
                                  },
                                  domProps: { value: _vm.data[index].name },
                                  on: {
                                    click: function($event) {
                                      return _vm.inputClick(index)
                                    },
                                    keyup: function($event) {
                                      return _vm.autoInsertOptions(
                                        _vm.data[index].name,
                                        index
                                      )
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.data[index],
                                        "name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-8" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-group row inner-option-name",
                              class: [{ disabled: _vm.data[index].name == "" }]
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-12",
                                  staticStyle: { position: "relative" }
                                },
                                [
                                  _vm.data[index].name == ""
                                    ? _c("div", {
                                        staticClass: "overlay-disable"
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("input-tags", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "message.options_colorsize"
                                      ),
                                      options: _vm.optionsAttributes,
                                      default:
                                        _vm.data[index].name !== ""
                                          ? _vm.inputTagOptions[index]
                                          : [],
                                      disabled: _vm.disabled
                                    },
                                    model: {
                                      value: _vm.data[index].options,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data[index],
                                          "options",
                                          $$v
                                        )
                                      },
                                      expression: "data[index].options"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.data.length > 1 &&
                              !_vm.disabled &&
                              _vm.data[index].name != ""
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn-delete",
                                      on: {
                                        click: function($event) {
                                          return _vm.del(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "far fa-trash-alt"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "mb-1" },
      [
        _c("section-title", { attrs: { title: _vm.$t("message.function") } }),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12 no-padding" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-md-12 col-lg-6" }, [
              _c("div", { staticClass: "form-group row mb-2" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "vs-checkbox",
                      {
                        staticStyle: { float: "left", margin: "0" },
                        attrs: { disabled: _vm.disabled, color: "#A3CA76" },
                        model: {
                          value: _vm.checkCopyPrice,
                          callback: function($$v) {
                            _vm.checkCopyPrice = $$v
                          },
                          expression: "checkCopyPrice"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.replaceprice")))]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row mb-2" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "vs-checkbox",
                      {
                        staticStyle: { float: "left", margin: "0" },
                        attrs: { disabled: _vm.disabled, color: "#A3CA76" },
                        model: {
                          value: _vm.checkCopyCost,
                          callback: function($$v) {
                            _vm.checkCopyCost = $$v
                          },
                          expression: "checkCopyCost"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("message.replacecost")))]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            !_vm.isFoundCustomSku(_vm.prices) || _vm.page == "new"
              ? _c("div", { staticClass: "col-md-12 col-lg-6" }, [
                  _c("div", { staticClass: "form-group row mb-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c(
                          "vs-checkbox",
                          {
                            staticStyle: { float: "left", margin: "0" },
                            attrs: { disabled: _vm.disabled, color: "#A3CA76" },
                            model: {
                              value: _vm.checkGenSku,
                              callback: function($$v) {
                                _vm.checkGenSku = $$v
                              },
                              expression: "checkGenSku"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("message.autogensku")))]
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.prices.length > 0
      ? _c(
          "section",
          { staticClass: "wrapper-prices mb-0" },
          [
            _c("section-title", {
              attrs: {
                title: _vm.$t("apps.pos.message.prices", {
                  number: _vm.prices.length
                })
              }
            }),
            _vm._v(" "),
            _vm._l(_vm.prices, function(data, index) {
              return _c(
                "div",
                { key: index, staticClass: "item col-md-12 no-padding mb-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12",
                      staticStyle: {
                        background: "#F5F5F5",
                        padding: "10px 10px 0 10px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "row",
                          staticStyle: { "margin-bottom": "8px" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            _vm._l(data.attributes, function(
                              attribute,
                              _index
                            ) {
                              return _c(
                                "span",
                                {
                                  key: _index,
                                  staticStyle: { "margin-right": "10px" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(attribute.name) +
                                      ": " +
                                      _vm._s(attribute.option)
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 text-right",
                              staticStyle: {
                                "max-height": "24px",
                                position: "relative",
                                right: "-9px"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("message.available")) +
                                  "\n            "
                              ),
                              _c("vs-switch", {
                                staticStyle: {
                                  float: "right",
                                  position: "relative",
                                  "margin-right": "10px",
                                  "margin-left": "10px"
                                },
                                attrs: {
                                  disabled: _vm.disabled,
                                  color: "#A3CA76"
                                },
                                model: {
                                  value: _vm.prices[index].is_available,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.prices[index],
                                      "is_available",
                                      $$v
                                    )
                                  },
                                  expression: "prices[index].is_available"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c("div", { staticClass: "input-group mb-10px" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn dropdown-toggle min-width-label text-left",
                                  staticStyle: { border: "1px solid #ced4da" },
                                  attrs: {
                                    disabled: _vm.disabled,
                                    type: "button",
                                    "data-toggle": "dropdown",
                                    "aria-haspopup": "true",
                                    "aria-expanded": "false"
                                  }
                                },
                                [
                                  data.is_fixedprice
                                    ? [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t("message.fixedprice")
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !data.is_fixedprice
                                    ? [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t("message.variableprice")
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-menu" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        data.is_fixedprice = true
                                        _vm.prices[
                                          index
                                        ].price = _vm.setToCustomDigitsNumber(0)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("message.fixedprice")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function($event) {
                                        data.is_fixedprice = false
                                        _vm.prices[index].price = null
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("message.variableprice"))
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.prices[index].price,
                                  expression: "prices[index].price"
                                }
                              ],
                              staticClass:
                                "form-control form-control-sm text-right text-select-all",
                              attrs: {
                                disabled: !data.is_fixedprice || _vm.disabled,
                                type: "text"
                              },
                              domProps: { value: _vm.prices[index].price },
                              on: {
                                keypress: _vm.numberOnly,
                                keyup: function($event) {
                                  _vm.prices[
                                    index
                                  ].price = _vm.setToValidNumber(
                                    _vm.prices[index].price
                                  )
                                  _vm.keyupPricce(_vm.prices[index].price)
                                },
                                blur: function($event) {
                                  _vm.prices[
                                    index
                                  ].price = _vm.setToCustomDigitsNumber(
                                    _vm.prices[index].price
                                  )
                                  _vm.setAllNumberToDigits()
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.prices[index],
                                    "price",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c("div", { staticClass: "input-group mb-10px" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "input-group-text min-width-label"
                                },
                                [_vm._v(_vm._s(_vm.$t("message.cost")))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.prices[index].cost,
                                  expression: "prices[index].cost"
                                }
                              ],
                              staticClass:
                                "form-control form-control-sm text-right text-select-all",
                              attrs: { disabled: _vm.disabled, type: "text" },
                              domProps: { value: _vm.prices[index].cost },
                              on: {
                                keypress: _vm.numberOnly,
                                keyup: function($event) {
                                  _vm.prices[index].cost = _vm.setToValidNumber(
                                    _vm.prices[index].cost
                                  )
                                  _vm.keyupCost(_vm.prices[index].cost)
                                },
                                blur: function($event) {
                                  _vm.prices[
                                    index
                                  ].cost = _vm.setToCustomDigitsNumber(
                                    _vm.prices[index].cost
                                  )
                                  _vm.setAllNumberToDigits()
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.prices[index],
                                    "cost",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-lg-6" }, [
                          _c("div", { staticClass: "input-group mb-10px" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "input-group-text min-width-label"
                                },
                                [_vm._v(_vm._s(_vm.$t("message.barcode")))]
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.prices[index].barcode,
                                  expression: "prices[index].barcode"
                                }
                              ],
                              staticClass:
                                "form-control form-control-sm text-right",
                              attrs: { disabled: _vm.disabled, type: "text" },
                              domProps: { value: _vm.prices[index].barcode },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.prices[index],
                                    "barcode",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-lg-12" }, [
                          _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "col-lg-6" }, [
                              _c(
                                "div",
                                { staticClass: "input-group mb-10px" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group-prepend" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "input-group-text min-width-label"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("message.sku")))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.prices[index].sku,
                                        expression: "prices[index].sku"
                                      }
                                    ],
                                    staticClass:
                                      "form-control form-control-sm text-right border-radius-right",
                                    class: [
                                      {
                                        "is-invalid": _vm.foundSkuCode(
                                          _vm.prices[index].sku
                                        )
                                      }
                                    ],
                                    attrs: {
                                      disabled: _vm.disabled,
                                      type: "text"
                                    },
                                    domProps: { value: _vm.prices[index].sku },
                                    on: {
                                      keyup: function($event) {
                                        _vm.prices[index].is_custom_sku = true
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.prices[index],
                                          "sku",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "invalid-feedback text-right"
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.$t("placeholder.unique")) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.page === "new"
                              ? _c("div", { staticClass: "col-lg-6" }, [
                                  _c(
                                    "div",
                                    { staticClass: "input-group mb-10px" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "input-group-prepend" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "input-group-text min-width-label"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.stockcount")
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.prices[index].stock_count,
                                            expression:
                                              "prices[index].stock_count"
                                          }
                                        ],
                                        staticClass:
                                          "form-control form-control-sm text-right text-select-all border-radius-right",
                                        attrs: { type: "text" },
                                        domProps: {
                                          value: _vm.prices[index].stock_count
                                        },
                                        on: {
                                          keypress: _vm.numberOnly,
                                          keyup: function($event) {
                                            _vm.prices[
                                              index
                                            ].stock_count = _vm.setToValidNumber(
                                              _vm.prices[index].stock_count
                                            )
                                          },
                                          blur: function($event) {
                                            _vm.prices[index].stock_count =
                                              _vm.prices[index].stock_count > 0
                                                ? _vm.setToCustomDigitsNumber(
                                                    _vm.prices[index]
                                                      .stock_count
                                                  )
                                                : null
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.prices[index],
                                              "stock_count",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]
                  )
                ]
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4ed9324", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4ed9324","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/Attribute.vue
// module id = null
// module chunks = 